import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homePageWidth"},[_c(VRow,[_c(VCol,{staticClass:"mt-5",attrs:{"cols":"12"}}),_c(VCol,[_vm._v("Digital Learning Design")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }